/* eslint-disable no-undef */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
// @ts-nocheck

import LoadingSpinner from "components/LoadingSpinner";
import PopupMessage from "components/popup-message";
import PopupOtp from "components/popup-otp";
import PopupWhishSuccess from "components/popup-succes-wish";
import PopupSuccessNote from "components/popup-success-note";
import PopupWhishNote from "components/popup-wish-note";
import AppConfigs from "configs/env";
import {
  CAMPAIGNID,
  END_DATE,
  frameList,
  LISTSONG,
  START_DATE,
  WISHLISTS,
} from "constants/common";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import actions from "redux/home/actions";
import Cookies from "universal-cookie";
import HomePageView from "./view";
import { requestButtonTracking } from "help/Tracking";

const HomePage = () => {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
    getValues,
    reset,
  } = useForm();
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const [modalOtp, setModalOtp] = useState(false);
  const [content, setContent] = useState("");
  const [otp, setOtp] = useState("");
  const [isErrorOTP, setIsErrorOTP] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [code, setCode] = useState("");
  const [birthDay, setBirthDay] = useState();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [fullName, setFullName] = useState("");
  const [address, setAddress] = useState("");
  const [OtpRequestTime, setOtpRequestTime] = useState("");
  const [OtpResponseTime, setOtpResponseTime] = useState("");
  const [dataSubmit, setDataSubmit] = useState({});
  const [nameBtn, setNameBtn] = useState("");
  const [nameBtn1, setNameBtn1] = useState("");
  const [groupBtnBlock, setGroupBtnBlock] = useState(false);
  const [nameBtn2, setNameBtn2] = useState("");
  const [timerId, setTimerId] = useState(null);
  const [isErrorPhoneNumber, setIsErrorPhoneNumber] = useState(false);
  const [genderSelected, setGenderSelected] = useState(null);
  const [rewardData, setRewardData] = useState({});
  const [valueDate, onChangeDate] = useState();
  const [showModalBirthday, setShowModalBirthday] = useState(false);
  const [isDisableInput, setIsDisableInput] = useState(false);
  const [isShowModalWhishNote, setIsShowModalWhishNote] = useState(false);
  const [isShowModalSuccessNote, setIsShowModalSuccessNote] = useState(false);
  const [isShowModalSuccessWish, setIsShowModalSuccessWish] = useState(false);
  const [wishContent, setWishContent] = useState(
    WISHLISTS.find((elm) => elm.obj === "default")?.description
  );
  const [wishActive, setWishActive] = useState("default");
  const [frameActive, setFrameActive] = useState("f1");
  const [songActive, setSongActive] = useState(1);
  const [searchParams] = useSearchParams();
  const codeRef = useRef("");
  const audioRef = useRef(null);
  const [textAreaCount, setTextAreaCount] = React.useState(0);
  const [isPlayAudio, setPlayAudio] = useState(false);
  const audioCurrentTimeRef = useRef(null);
  const [blockList, setBlockList] = useState([]);
  const [isValidWishContent, setValidWishContent] = useState(false);
  const actionTypeRef = useRef("");

  useEffect(() => {
    reset();

    getCampaignInfo();
    getBlockList();
    document.body.classList.add("bgr-blue");
    document.body.classList.remove("bgr-game");

    stopTimer();
  }, []);

  const getBlockList = () => {
    dispatch(
      actions.GET_BLOCK_LIST.request(
        null,
        (res) => {
          setBlockList(res);
        },
        (err) => {}
      )
    );
  };

  const recalculate = (e) => {
    console.log("event value:", e);
    setTextAreaCount(e.target.value.length);
  };
  const _onClickSong = (index) => {
    try {
      audioCurrentTimeRef.current = 0;
      if (audioRef.current !== null && !audioRef.current?.paused) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0; // Rewind track to beginning (is you need this)
        // if (audioRef.current?.paused) {
        const songURL = LISTSONG.find((elm) => elm.id === index)?.link;
        audioRef.current = new Audio(songURL);
        setPlayAudio(true);
        audioRef.current.play();
        audioRef.current.addEventListener("ended", function () {
          audioRef.current.currentTime = 0;
          console.log("ended");
          setPlayAudio(false);
        });
      } else {
        const songURL = LISTSONG.find((elm) => elm.id === index)?.link;
        audioRef.current = new Audio(songURL);
        setPlayAudio(true);
        audioRef.current.play();
        audioRef.current.addEventListener("ended", function () {
          audioRef.current.currentTime = 0;
          console.log("ended");
          setPlayAudio(false);
        });
      }
    } catch (error) {}

    setSongActive(index);
  };
  document.addEventListener("visibilitychange", () => {
    if (document.hidden) {
      audioRef?.current?.pause();
      setPlayAudio(false);
    }
  });
  const hideModal = () => {
    setModal(false);
    setContent("");
    setNameBtn("");
    setNameBtn1("");
    setNameBtn2("");
    document.body.classList.remove("modal-open");
  };
  const startTimer = () => {
    if (timerId) clearTimeout(timerId);
    setTimerId(setTimeout(hideModal, 10000));
  };

  const stopTimer = () => clearTimeout(timerId);

  const removeModalOpen = () => {
    setIsLoading(false);
    document.body.classList.remove("modal-open");
  };

  useEffect(() => {
    if (wishContent.length > 0 && blockList.length > 0) {
      let temp = false;
      for (let i = 0; i < blockList.length; i++) {
        const element = blockList[i].toLowerCase();
        if (wishContent.toLowerCase().indexOf(element) > -1) {
          temp = true;
          break;
        }
        if (i === blockList.length - 1) {
          temp = false;
        }
      }
      setValidWishContent(temp);
    } else {
      if (wishContent.length === 0) {
        setValidWishContent(false);
      }
      if (wishContent.length > 0 && !blockList.length) {
        setValidWishContent(true);
      }
    }
  }, [wishContent, blockList]);

  const getCampaignInfo = () => {
    setIsLoading(true);
    dispatch(
      actions.GET_CAMPAIGN_INFO.request(
        {},
        (res) => {
          if (!!res?.id) {
            localStorage.setItem("campaignInfo", JSON.stringify(res));
          }
          const isShowPopup = searchParams.get("code") ? true : false;
          codeRef.current = searchParams.get("code");
          const codeTemp = localStorage.getItem("cghjfkhgj");
          codeRef.current = codeRef.current || codeTemp;
          if (codeRef.current) {
            localStorage.setItem("cghjfkhgj", codeRef.current);
            dispatch(
              actions.VALIDATE_CODE.request(
                codeRef.current,
                (res) => {
                  setIsLoading(false);
                  if (res?.canWriteGreeting) {
                    let saveDraft = localStorage.getItem(codeRef.current);
                    if (saveDraft) {
                      try {
                        saveDraft = JSON.parse(saveDraft);
                        setWishContent(saveDraft?.wishContent);
                        setWishActive(saveDraft?.obj);
                        setSongActive(saveDraft?.songLink);
                        setFrameActive(
                          frameList.find(
                            (item) => item.name === saveDraft?.greetingFrame
                          )?.id
                        );
                      } catch (error) {}
                    } else {
                      showModalNoSaveNote();
                    }
                  } else {
                    localStorage.setItem("wish", JSON.stringify(res));
                    navigate("/information", {
                      state: { wishData: res, isShowPopup },
                    });
                  }
                },
                (err) => {
                  setIsLoading(false);
                  navigate("/guide");
                }
              )
            );
          } else {
            setIsLoading(false);
            navigate("/guide");
          }
        },
        (err) => {
          setIsLoading(false);
          checkError(err?.data?.error?.code);
        }
      )
    );
  };
  const showModalNoSaveNote = () => {
    showModal();
    setContent(
      `Bạn có muốn tự tạo lời chúc và <br/>
      gửi đến người mà bạn yêu quý không?`
    );
    setNameBtn1(`CÓ, TẠO LỜI CHÚC NGAY!`);
    setNameBtn2(`KHÔNG, NHẬN QUÀ TỪ P/S`);
    setGroupBtnBlock(true);
  };
  const showModalWhish = () => {
    setIsShowModalWhishNote(true);
  };
  const showModalSaveNote = () => {
    showModal();
    setContent(
      `Nội dung lời chúc sẽ được lưu lại, bạn có thể quay lại và hoàn thành lời chúc sau đó`
    );
    setNameBtn1(`Hủy bỏ`);
    setNameBtn2(`Lưu lời chúc`);
    setGroupBtnBlock(false);
  };
  const showModalSuccessNote = () => {
    setIsShowModalSuccessNote(true);
  };

  const showModal = () => {
    setModalOtp(false);
    setModal(true);
    document.body.classList.add("modal-open");
  };
  const closeModalOTP = () => {
    setIsErrorOTP(false);
    setOtp("");
    setModalOtp(false);
    document.body.classList.remove("modal-open");
    removeDisableBtn("#btn-register");
  };
  const onSubmit = (data) => {
    if (
      data.code !== "" &&
      data.fullName !== "" &&
      data.phone !== "" &&
      data.isAgree
    ) {
      handleJoin(data);
      setDataSubmit(data);
    }
  };

  const handleJoin = (data) => {
    if (data.code === "") {
      setContent(`Mã dự thưởng không hợp lệ!<br/>
        Vui lòng kiểm tra lại`);
      setNameBtn(`ĐÓNG`);
      showModal();
    } else {
      requestOTP(data);
      document.body.classList.add("modal-open");
    }
  };

  const removeDisableBtn = (id) => {
    const el = document.querySelector(id);
    el.classList.remove("disabled");
  };

  const handleSubmitOTP = () => {
    console.log("OTP===>", otp);
    setIsLoading(true);
    updateUserInfo();
  };

  const resendOTP = () => {
    setIsErrorOTP(false);
    setOtp("");
    requestOTP(dataSubmit);
  };

  const updateUserInfo = () => {
    if (!!code) {
      dispatch(
        actions.EXCHANGE_CODE.request(
          {
            code: code,
            phoneNumber: phoneNumber,
            userName: fullName,
            dOB: birthDay || "",
            gender: genderSelected || null,
            otp: otp,
          },
          (res) => {
            setIsLoading(false);
            console.log("res===", res);
            if (!!res?.reward?.rewardId) {
              console.log("res===reward?", res?.reward);
              localStorage.setItem("rewardData", JSON.stringify(res?.reward));

              navigate("/game");
            } else {
              showDefaultErrModal();
            }
          },
          (err) => {
            setIsLoading(false);
            if (err?.status !== 500) {
              let errCode = err.data.error.errorCode;
              console.log("errCode=====>", err.data.error.errorCode);

              if (errCode == "InvalidOtp") {
                setIsErrorOTP(true);
              } else {
                checkError(errCode);
              }
            } else {
              showDefaultErrModal();
            }
          }
        )
      );
    }
    // setIsLoading(true);
    // dispatch(
    //   actions.UPDATE_USER_INFO.request(
    //     {
    //       code: code,
    //       phoneNumber: phoneNumber,
    //       userName: fullName,
    //       dOB: birthDay,
    //       gender: genderSelected,
    //       otp: otp,
    //     },
    //     (res) => {
    //       // requestGigya();
    //       // exchangeCode();
    //       // hideModal();
    //       // console.log("success");
    //       setIsLoading(false);
    //       localStorage.setItem("exchangecode", JSON.stringify(res));
    //     },
    //     (err) => {
    //       // removeModalOpen();
    //       setIsLoading(false);
    //       localStorage.setItem("exchangecode", JSON.stringify(res));
    //     }
    //   )
    // );
  };

  const checkError = (errCode) => {
    let content = "";
    switch (errCode) {
      case "InvalidCode":
        showModal();
        setNameBtn(`ĐÓNG`);
        content = `Mã số <b>${code}</b> không hợp lệ hoặc đã được sử dụng. Quý khách vui lòng thử lại.`;
        break;
      case "FinishedError":
        content = `Chương trình đã kết thúc vào ngày 19/01/2025. Hẹn gặp lại bạn trong các chương trình sau nhé.`;
        setNameBtn(`ĐÓNG`);
        setIsDisableInput(true);
        break;
      case "No_Available_Rewards_Error":
        showModal();
        setNameBtn(`ĐÓNG`);
        content = `Chương trình đã kết thúc do số lượng quà đã hết. `;
        break;

      case "BlockedUser":
        showModal();
        setNameBtn(`ĐÓNG`);
        content = `Rất tiếc, Quý khách đã bị chặn vì nhập sai mã số quá 5 lần. Qúy khách vui lòng quay trở lại sau`;
        break;
      case "DuplicateAttemp":
        showModal();
        setNameBtn(`ĐÓNG`);
        content = `Mã số <b>${code}</b> không hợp lệ hoặc đã được sử dụng. Quý khách vui lòng thử lại.`;
        break;

      case "NotStartYetError":
        content = `Chương trình chưa bắt đầu. Vui lòng quay trở lại sau ngày <span>${START_DATE}</span>.
        `;
        actionTypeRef.current = "GO_TO_GUIDE";
        // startTimer();
        break;

      case "CampaignIsOver":
        content = `Chương trình đã kết thúc vào ngày <strong>${END_DATE}</strong>. Hẹn gặp lại bạn trong các chương trình sau.`;
        // startTimer();
        break;

      case "OUT_OF_STOCK":
        content = `Chương trình đã kết thúc trước thời hạn do hết quà. Cảm ơn bạn đã quan tâm đến chương trình và tin dùng sản phẩm từ P/S.`;
        setNameBtn(`ĐÓNG`);
        actionTypeRef.current = "GO_TO_GUIDE";
        localStorage.removeItem("sjkhjk");
        localStorage.removeItem("cghjfkhgj");
        localStorage.removeItem("tjfsaj");
        localStorage.removeItem("wish");
        break;

      case "CAMPAIGN_NOT_START_YET":
        content = `Chương trình chưa bắt đầu. <br />
          Vui lòng quay trở lại vào ngày ${AppConfigs.startDate}`;
        actionTypeRef.current = "GO_TO_GUIDE";
        setNameBtn(`ĐÓNG`);
        break;

      case "CAMPAIGN_ENDED":
        content = `Chương trình đã kết thúc vào ngày ${AppConfigs.endDate}.<br /> Hẹn gặp lại bạn trong các chương trình sau nhé.`;
        // setNameBtn(`ĐÓNG`);
        // actionTypeRef.current = "GO_TO_GUIDE";
        break;

      case "CODE_IS_USED":
        content = `Mã qrcode này đã được ghi nhận lời chúc rồi, bạn vui lòng kiểm tra lại nhé`;
        setNameBtn(`ĐÓNG`);
        break;

      default:
        content = `Đã có lỗi xảy ra.<br/>
        Quý khách vui lòng thử lại sau.`;
        setNameBtn(`ĐÓNG`);
        break;
    }
    showModal();
    setContent(`${content}`);
  };

  const showDefaultErrModal = () => {
    setNameBtn(`ĐÓNG`);
    content = `Đã có lỗi xảy ra.<br/>
    Quý khách vui lòng thử lại sau.`;
    showModal();
  };

  const requestOTP = (data) => {
    setIsLoading(true);
    console.log("data", data);
    setOtpRequestTime(moment().utc().format());
    localStorage.setItem("accessToken", "");
    setIsErrorOTP(false);
    setOtp("");
    dispatch(
      actions.REQUEST_OTP.request(
        {
          phoneNumber: data.phone,
          campaignId: parseInt(CAMPAIGNID),
        },
        (res) => {
          setOtpResponseTime(moment().utc().format());
          // OTPLog(res, data);
          setCode(data.code);
          setBirthDay(data.birthday);
          setPhoneNumber(data.phone);
          setFullName(data.fullName);
          setAddress(data.address);
          setModalOtp(true);
          console.log("success");
          removeModalOpen();
          setIsLoading(false);
        },
        (err) => {
          removeModalOpen();
          setIsLoading(false);
          removeDisableBtn("#btn-register");
        }
      )
    );
  };

  const clickAction3 = () => {
    hideModal();
    navigate("/");
  };
  const clickAction4 = () => {
    requestButtonTracking("button_Receive_gifts_from_PS", "Khong,nhanquatuP/S");
    hideModal();
    submitWish(() => {
      setIsShowModalSuccessWish(true);
      hideSuccessNote();
      navigate("/information");
    });
  };
  const clickAction = (e) => {
    switch (actionTypeRef.current) {
      case "GO_TO_INFORMATION":
        navigate("/information");
        break;

      case "GO_TO_GUIDE":
        navigate("/guide");
        break;

      case "FETCH_GIFTS":
        getGifts();
        break;

      default:
        hideModal();
        localStorage.setItem("accessToken", "");
        localStorage.setItem("userData", JSON.stringify({}));
        break;
    }
  };

  const clickAction2 = (e) => {
    if (codeRef.current) {
      const wishDraft = {
        obj: wishActive,
        wishContent: wishContent,
        songLink: songActive,
        greetingFrame: frameList.find((item) => item.id === frameActive)?.name,
      };
      localStorage.setItem(codeRef.current, JSON.stringify(wishDraft));
    }
    hideModal();
  };

  const closeModalWhishNote = () => {
    setIsShowModalWhishNote(false);
    hideModal();
  };
  const clickGoSuccessWish = () => {
    submitWish(() => {
      setIsShowModalSuccessWish(true);
      hideSuccessNote();
    });
  };
  const hideSuccessNote = () => {
    hideModal();
    setIsShowModalSuccessNote(false);
  };
  const hideSuccessWish = () => {
    hideModal();
    setIsShowModalSuccessWish(false);
    navigate("/guide");
    try {
      audioRef.current?.pause();
    } catch (error) {}
  };

  const submitWish = (callBack) => {
    dispatch(
      actions.SUBMIT_WISH.request(
        {
          code: codeRef.current,
          message: wishContent,
          songLink: LISTSONG.find((elm) => elm.id === songActive)?.link,
          FrameLink: frameList.find((item) => item.id === frameActive)?.name,
        },
        (res) => {
          callBack();
        },
        (err) => {
          checkError(err?.data?.error?.code);
        }
      )
    );
  };

  return (
    <div
      onClick={() => {
        if (modalOtp) {
          hideModal();
        }
      }}
    >
      <LoadingSpinner isLoading={isLoading} />
      <HomePageView
        register={register}
        setValue={setValue}
        getValues={getValues}
        handleSubmit={handleSubmit(onSubmit)}
        rewardData={rewardData}
        isErrorPhoneNumber={isErrorPhoneNumber}
        valueDate={valueDate}
        showModalBirthday={showModalBirthday}
        isDisableInput={isDisableInput}
        showModalWhish={showModalWhish}
        showModalSaveNote={showModalSaveNote}
        // showModalNoSaveNote={showModalNoSaveNote}
        showModalSuccessNote={showModalSuccessNote}
        wishContent={wishContent}
        setWishContent={setWishContent}
        wishActive={wishActive}
        setWishActive={setWishActive}
        songActive={songActive}
        setSongActive={setSongActive}
        audioRef={audioRef}
        _onClickSong={_onClickSong}
        recalculate={recalculate}
        textAreaCount={textAreaCount}
        isPlayAudio={isPlayAudio}
        setPlayAudio={setPlayAudio}
        audioCurrentTimeRef={audioCurrentTimeRef}
        blockList={blockList}
        isValidWishContent={isValidWishContent}
        frameActive={frameActive}
        setFrameActive={setFrameActive}
      />

      {modalOtp && (
        <PopupOtp
          setModal={setModalOtp}
          setOtp={setOtp}
          otp={otp}
          handleSubmitOTP={handleSubmitOTP}
          closeModalOTP={closeModalOTP}
          resendOTP={resendOTP}
          isErrorOTP={isErrorOTP}
        />
      )}
      {isShowModalWhishNote && (
        <PopupWhishNote
          wishContent={wishContent}
          closeModal={closeModalWhishNote}
        />
      )}

      {isShowModalSuccessNote && (
        <PopupSuccessNote
          clickAction={hideSuccessNote}
          clickAction1={clickGoSuccessWish}
        />
      )}
      {isShowModalSuccessWish && (
        <PopupWhishSuccess clickAction={hideSuccessWish} />
      )}

      {modal && (
        <PopupMessage
          nameBtn={nameBtn}
          nameBtn1={nameBtn1}
          nameBtn2={nameBtn2}
          setModal={setModal}
          content={content}
          groupBtnBlock={groupBtnBlock}
          clickAction={clickAction}
          clickAction1={clickAction}
          clickAction2={clickAction2}
          clickAction3={clickAction3}
          clickAction4={clickAction4}
        />
      )}
    </div>
  );
};

export default HomePage;
